/** Erros do protocolo. Nenhum deles carrega material secreto na mensagem. */

export class CryptoNotInitializedError extends Error {
  constructor() {
    super('crypto-core nao inicializado: chame initCrypto() antes de qualquer operacao')
    this.name = 'CryptoNotInitializedError'
  }
}

/**
 * Falha de autenticacao. A mensagem e deliberadamente generica: distinguir
 * "tag invalida" de "chave errada" daria um oraculo ao atacante (SECURITY.md, regra 7).
 */
export class DecryptionFailedError extends Error {
  constructor() {
    super('falha ao decifrar')
    this.name = 'DecryptionFailedError'
  }
}

export class InvalidSignatureError extends Error {
  constructor(what: string) {
    super(`assinatura invalida: ${what}`)
    this.name = 'InvalidSignatureError'
  }
}

export class MalformedFrameError extends Error {
  constructor(why: string) {
    super(`quadro malformado: ${why}`)
    this.name = 'MalformedFrameError'
  }
}

/** Mais mensagens puladas do que a janela permite — provavel ataque de exaustao. */
export class TooManySkippedMessagesError extends Error {
  constructor(limit: number) {
    super(`mais de ${limit} mensagens puladas; sessao recusa avancar`)
    this.name = 'TooManySkippedMessagesError'
  }
}

/** Pad OTP sem bytes suficientes. NUNCA reutilizar o que ja foi consumido. */
export class PadExhaustedError extends Error {
  constructor(need: number, have: number) {
    super(`pad esgotado: precisa de ${need} bytes, restam ${have}`)
    this.name = 'PadExhaustedError'
  }
}

/**
 * A OTPK citada na primeira mensagem nao existe mais (ja consumida, ou
 * mensagem repetida). Falhar aqui e melhor do que derivar um segredo
 * diferente em silencio e so descobrir na hora de decifrar.
 */
export class PreKeyUnavailableError extends Error {
  constructor(keyId: number) {
    super(`one-time prekey ${keyId} indisponivel`)
    this.name = 'PreKeyUnavailableError'
  }
}

/**
 * Quem responde ainda nao pode enviar: precisa receber a primeira mensagem
 * para o ratchet ter um sentido de envio. Nao e falha criptografica.
 */
export class SessionNotReadyError extends Error {
  constructor() {
    super('sessao ainda nao pode enviar: aguarde a primeira mensagem do contato')
    this.name = 'SessionNotReadyError'
  }
}

/**
 * O bundle devolvido pelo servidor nao corresponde ao fingerprint pedido.
 *
 * E o ataque que o codigo de 6 palavras sozinho NAO pegaria: se a Mallory
 * registrar as chaves dela sob o fingerprint do Bob, a Alice calcularia o
 * codigo a partir do fingerprint do Bob — que ela ja tem — e ele bateria,
 * enquanto a sessao estaria com a Mallory. A amarracao tem de ser conferida
 * aqui, no cliente, antes de qualquer DH.
 */
export class FingerprintMismatchError extends Error {
  constructor() {
    super('as chaves recebidas nao correspondem ao fingerprint do contato')
    this.name = 'FingerprintMismatchError'
  }
}
